<template>
  <div class="app-container">
    <layouts-header></layouts-header>
    <div class="content-wrapper">
      <layouts-sidebar></layouts-sidebar>
      <div class="main-content">
        <div class="profile-update">
          <!-- Tab Navigation -->
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <button
                class="nav-link"
                :class="{ active: activeTab === 'profile' }"
                @click="activeTab = 'profile'"
              >
                Profile Update
              </button>
            </li>
            <li class="nav-item">
              <button
                class="nav-link"
                :class="{ active: activeTab === 'password' }"
                @click="activeTab = 'password'"
              >
                Password Change
              </button>
            </li>
          </ul>

          <!-- Tab Content -->
          <div v-if="activeTab === 'profile'">
            <h3 class="pb-2"><u>Update Profile</u></h3>
            <form @submit.prevent="updateProfile">
              <div class="form-group">
                <label for="profile-picture">Profile Picture</label>
                <input
                  type="file"
                  id="profile-picture"
                  @change="handleFileChange"
                  class="form-control"
                  accept="image/*"
                />
                <div class="text-danger" v-if="errors.profile_picture">
                  {{ errors.profile_picture[0] }}
                </div>
              </div>

              <!-- Image Preview -->
              <div class="form-group" v-if="profile.profile_picture_preview">
                <img
                  :src="profile?.profile_picture_preview"
                  alt="Profile Picture Preview"
                  class="img-thumbnail"
                  style="max-width: 200px; max-height: 200px"
                />
              </div>
              <div class="form-group">
                <label for="name"
                  >Name <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  id="name"
                  v-model="profile.name"
                  class="form-control"
                />
                <div class="text-danger" v-if="errors.name">
                  {{ errors.name[0] }}
                </div>
              </div>
              <div class="form-group">
                <label for="email"
                  >Email <span class="text-danger">*</span></label
                >
                <input
                  type="email"
                  id="email"
                  v-model="profile.email"
                  class="form-control"
                />
                <div class="text-danger" v-if="errors.email">
                  {{ errors.email[0] }}
                </div>
              </div>
              <div class="form-group">
                <label for="phone"
                  >Phone <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="profile.phone"
                />
                <div class="text-danger" v-if="errors.phone">
                  {{ errors.phone[0] }}
                </div>
              </div>
              <div class="form-group">
                <label for="address">Address</label>
                <textarea
                  class="form-control"
                  rows="3"
                  v-model="profile.address"
                ></textarea>
              </div>
              <button type="submit" class="btn btn-primary">
                <span v-if="!isLoading">Update Profile</span>
                <span v-else>Loading...</span>
              </button>
            </form>
          </div>

          <div v-if="activeTab === 'password'">
            <h3 class="pb-2"><u>Change Password</u></h3>
            <form @submit.prevent="changePassword">
              <div class="form-group">
                <label for="current-password">Current Password</label>
                <input
                  type="password"
                  id="current-password"
                  v-model="passwords.current_password"
                  class="form-control"
                />
                <div class="text-danger" v-if="errors.current_password">
                  {{ errors.current_password[0] }}
                </div>
              </div>
              <div class="form-group">
                <label for="new-password">New Password</label>
                <input
                  type="password"
                  id="new-password"
                  v-model="passwords.new_password"
                  class="form-control"
                />
                <div class="text-danger" v-if="errors.new_password">
                  {{ errors.new_password[0] }}
                </div>
              </div>
              <div class="form-group">
                <label for="confirm-password">Confirm Password</label>
                <input
                  type="password"
                  id="confirm-password"
                  v-model="passwords.new_password_confirmation"
                  class="form-control"
                />
                <!-- <div class="text-danger" v-if="errors.new_password">
                    {{ errors.new_password[0] }}
                  </div> -->
              </div>
              <button type="submit" class="btn btn-secondary">
                <span v-if="!isLoading">Change Password</span>
                <span v-else>Loading...</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      activeTab: "profile",
      profile: {
        id: "",
        name: "",
        email: "",
        phone: "",
        address: "",
        profile_picture: null,
        profile_picture_preview: null,
      },
      passwords: {
        current_password: "",
        new_password: "",
        new_password_confirmation: "",
      },
      errors: {},
      isLoading: false,
    };
  },
  mounted() {
    if (this.userInfo?.name) {
      this.setProfileInfo();
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    userInfo: {
      immediate: true,
      handler(newUserInfo) {
        if (newUserInfo?.name) {
          this.setProfileInfo();
        }
      },
    },
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.profile.profile_picture = file;
        this.profile.profile_picture_preview = URL.createObjectURL(file);
      }
    },
    setProfileInfo() {
      this.profile = {
        id: this.userInfo?.id || null,
        name: this.userInfo?.name || "",
        email: this.userInfo?.email || "",
        phone: this.userInfo?.employee?.phone || "",
        address: this.userInfo?.employee?.address || "",
        profile_picture:
          this.userInfo?.employee?.profile_picture ||
          require("@/assets/img/profiles/avatar-14.jpg"),
        profile_picture_preview:
          this.userInfo?.employee?.profile_picture ||
          require("@/assets/img/profiles/avatar-14.jpg"),
      };
    },

    async updateProfile() {
      this.isLoading = true;

      const formData = new FormData();
      formData.append("id", this.profile.id);
      formData.append("name", this.profile.name);
      formData.append("email", this.profile.email);
      formData.append("phone", this.profile.phone);
      formData.append("address", this.profile.address);

      if (this.profile.profile_picture) {
        formData.append("profile_picture", this.profile.profile_picture);
      }

      const endpoint = "/user-profile-update";
      const method = "post";

      try {
        const response = await http[method](endpoint, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        this.$store.dispatch("fetchRolePermissions");

        this.$toast.success(response.data.message);
      } catch (error) {
        console.log("profile updat error", error?.response?.data?.message);
        this.$toast.error(error?.response?.data?.message);
        this.errors = error.response.data.errors;
      } finally {
        this.isLoading = false;
      }
    },

    async changePassword() {
      if (
        this.passwords.new_password !== this.passwords.new_password_confirmation
      ) {
        this.$toast.error("New password and confirm password do not match.");
        return;
      }
      this.isLoading = true;
      const endpoint = "/user-password-change";
      const method = "post";
      try {
        const response = await http[method](endpoint, this.passwords);

        this.$toast.success(response.data.message);
        this.logout();
      } catch (error) {
        if (error.response && error.response.data) {
          if (error.response.data.message) {
            this.$toast.error(error.response.data.message);
          }

          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        } else {
          this.$toast.error("An unexpected error occurred. Please try again.");
        }
      } finally {
        this.isLoading = false;
      }
    },

    async logout() {
      try {
        const response = await http.post("/logout");

        this.$toast.success(response.data.message);
        localStorage.removeItem("bearer_token");
        localStorage.removeItem("token_expiration");
        this.$router.push("/");
      } catch (error) {
        console.error("Error during logout:", error);
      }
    },
  },
};
</script>

<style scoped>
.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

layouts-header {
  flex: 0 0 auto;
}

.content-wrapper {
  display: flex;
  flex: 1;
  overflow: hidden;
}

layouts-sidebar {
  flex: 0 0 250px; /* Adjust width as needed */
  height: calc(100vh - var(--header-height));
  background: #f8f9fa; /* Sidebar background color */
}

.main-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.profile-update {
  max-width: 600px;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-top: 70px;
}

/* Tabs */
.nav-tabs {
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
}

.nav-item .nav-link {
  cursor: pointer;
  padding: 10px 20px;
  border: 1px solid transparent;
  border-radius: 4px 4px 0 0;
}

.nav-item .nav-link.active {
  background-color: #007bff;
  color: #fff;
  border-color: #ddd #ddd #fff;
}

/* Form Buttons */
.profile-update form .btn {
  margin-top: 15px; /* Add spacing above the buttons */
  margin-right: 10px; /* Add spacing between buttons if multiple are present */
}
</style>
